import React from 'react';
import styles from './index.less';

const MobileGuide: React.FC = () => {
  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <div className={styles.text}>
          请在电脑端浏览
          <br />
          中关村中安安防产业发展促进会官网
        </div>
        <div className={styles.subText}>
          您也可以扫码访问公众号
        </div>
        <img 
          src="/assets/mpqrcode.jpg" 
          alt="公众号二维码" 
          className={styles.qrcode}
        />
      </div>
    </div>
  );
};

export default MobileGuide;
